export default "__VITE_ASSET__02e77859__"